import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import BlocksPage from './pages/BlocksPage';
import TransactionsPage from './pages/TransactionsPage';
import AddressPage from './pages/AddressPage';
import AddressesPage from './pages/AddressesPage';
import BlockDetailPage from './pages/BlockDetailPage';
import TokensPage from './pages/TokensPage';
import TokenDetailPage from './pages/TokenDetailPage';
import ValidatorsPage from './pages/ValidatorsPage';
import SubnetsPage from './pages/SubnetsPage';
import StakingPage from './pages/StakingPage';
import GovernancePage from './pages/GovernancePage';
import NetworkStatusPage from './pages/NetworkStatusPage';
import BoomEventsPage from './pages/BoomEventsPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import ReferralCodesPage from './pages/admin/ReferralCodesPage';
import UserManagementPage from './pages/admin/UserManagementPage';
import BridgeManagementPage from './pages/admin/BridgeManagementPage';
import StakingProductsPage from './pages/admin/StakingProductsPage';
import SettlementPage from './pages/admin/SettlementPage';
import FoundationWalletPage from './pages/admin/FoundationWalletPage';
import NodeSubscriptionPage from './pages/admin/NodeSubscriptionPage';
import SystemLogsPage from './pages/admin/SystemLogsPage';
import SecurityPage from './pages/admin/SecurityPage';
import TokenMintingPage from './pages/admin/TokenMintingPage';
import VoltronTokenManagementPage from './pages/admin/VoltronTokenManagementPage';
import BonusManagementPage from './pages/admin/BonusManagementPage';
import WalletManagementPage from './pages/admin/WalletManagementPage';
import DiscountManagementPage from './pages/admin/DiscountManagementPage';
import EnergyBSSPage from './pages/EnergyBSSPage';
import TokenTransferPage from './pages/TokenTransferPage';
import WalletPage from './pages/WalletPage';
import ReferralsPage from './pages/ReferralsPage';
import ReferralManagementPage from './pages/admin/ReferralManagementPage';
import ServiceManagementPage from './pages/admin/ServiceManagementPage';
import BridgePage from './pages/BridgePage';
import AnalyticsPage from './pages/AnalyticsPage';
import NotificationsPage from './pages/NotificationsPage';
import './App.css';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  return (
    <LanguageProvider>
    <Router>
      <div className="min-h-screen bg-white flex">
        {/* 좌측 사이드바 */}
        <Sidebar />
        
        {/* 메인 컨텐츠 영역 */}
        <div className="flex-1 flex flex-col">
          {/* 상단 헤더 */}
          <Header />
          
          {/* 메인 컨텐츠 */}
          <main className="flex-1 p-6 bg-gray-50">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/wallet" element={<WalletPage />} />
              <Route path="/blocks" element={<BlocksPage />} />
              <Route path="/block/:blockNumber" element={<BlockDetailPage />} />
              <Route path="/transactions" element={<TransactionsPage />} />
              <Route path="/addresses" element={<AddressesPage />} />
              <Route path="/address/:address" element={<AddressPage />} />
              <Route path="/tokens" element={<TokensPage />} />
                <Route path="/token/:address" element={<TokenDetailPage />} />
                <Route path="/validators" element={<ValidatorsPage />} />
              <Route path="/subnets" element={<SubnetsPage />} />
              <Route path="/staking" element={<StakingPage />} />
              <Route path="/governance" element={<GovernancePage />} />
              <Route path="/network" element={<NetworkStatusPage />} />
              <Route path="/energy-bss" element={<EnergyBSSPage />} />

              <Route path="/bridge" element={<BridgePage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/voltron-token" element={<VoltronTokenManagementPage />} />
              <Route path="/admin/bonus-management" element={<BonusManagementPage />} />
              <Route path="/admin/wallet-management" element={<WalletManagementPage />} />
              <Route path="/admin/discount-management" element={<DiscountManagementPage />} />
              <Route path="/admin/user-management" element={<UserManagementPage />} />
              <Route path="/admin/staking" element={<StakingPage />} />
              <Route path="/admin/node-subscription" element={<NodeSubscriptionPage />} />
              <Route path="/admin/token-transfer" element={<TokenTransferPage />} />
              <Route path="/admin/token-minting" element={<TokenMintingPage />} />
              <Route path="/admin/boom-events" element={<BoomEventsPage />} />
              <Route path="/admin/referrals" element={<ReferralsPage />} />
              <Route path="/admin/referral-management" element={<ReferralManagementPage />} />
              <Route path="/admin/service-management" element={<ServiceManagementPage />} />
              <Route path="/admin/settlement" element={<SettlementPage />} />
              <Route path="/admin/foundation-wallet" element={<FoundationWalletPage />} />
              <Route path="/admin/logs" element={<SystemLogsPage />} />
              <Route path="/admin/security" element={<SecurityPage />} />
            </Routes>
          </main>
        </div>
      </div>
    </Router>
    </LanguageProvider>
  );
}

export default App;
